import { render, staticRenderFns } from "./bindtel.vue?vue&type=template&id=d321d5a0&scoped=true&"
import script from "./bindtel.vue?vue&type=script&lang=js&"
export * from "./bindtel.vue?vue&type=script&lang=js&"
import style0 from "./bindtel.vue?vue&type=style&index=0&id=d321d5a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d321d5a0",
  null
  
)

export default component.exports